class SystemInformation {
  constructor() {
    if (SystemInformation._systemInformationInstance) {
      SystemInformation._systemInformationInstance._systemInformation = null;
      return SystemInformation._systemInformationInstance;
    }
    SystemInformation._systemInformationInstance = this;
    this._systemInformation = null;
    this._generalFunctions = null;
    this._subscribersToUpdate = new Set();
    this._startupPromise = null; // Add this line to track ongoing startup
  }

  wipe() {
    this._systemInformation = null;
    this._generalFunctions = null;
    this._subscribersToUpdate = new Set();
    this._startupPromise = null; // Clear the promise
  }

  async startup() {
    // If startup is already in progress, return the existing promise
    if (this._startupPromise) {
      return this._startupPromise;
    }

    // Create new startup promise
    this._startupPromise = new Promise((startupPromiseResolve) => {
      try {
        if (this._systemInformation) {
          if (this._systemInformation.CRMAgent && 
              this._systemInformation.CRMLocalities && 
              this._systemInformation.CRMWhatsappMediaCatalogs) {
            this._startupPromise = null; // Clear the promise
            return startupPromiseResolve({success: true, result: this._systemInformation});
          }
          this._systemInformation = null;
        }
        
        if (!this._generalFunctions) {
          this._startupPromise = null; // Clear the promise
          return startupPromiseResolve({success: false, result: '1'});
        }
        
        this._systemInformation = 
        {
          'CRMAccountID': localStorage.getItem('CRMAccountID'),
          'CRMAgentID': localStorage.getItem('CRMAgentID'),
          'tooltipDisabled': localStorage.getItem('tooltipDisabled') == 'true',
          'volumeLevel': localStorage.getItem('volumeLevel'),
          'CRMWhatsappMessageNotificationDisabled': localStorage.getItem('CRMWhatsappMessageNotificationDisabled') == 'true',
          'CRMLocalities': [],
          'CRMAgents': [],
          'CRMWhatsappMediaCatalogs': [],
          'CRMAgent': null
        };

        Promise.all([
          this.loadCRMLocalities(),
          this.loadCRMAgents(),
          this.loadCRMWhatsappMediaCatalogs(),
          this.loadCRMAgent()
        ]).then(([localitiesResult, agentsResult, mediaCatalogsResult, agentResult]) => {
          if (!localitiesResult.success) {
            this._startupPromise = null; // Clear the promise
            return startupPromiseResolve({success: false, result: '3'});
          }
          if (!agentsResult.success) {
            this._startupPromise = null; // Clear the promise
            return startupPromiseResolve({success: false, result: '4'});
          }
          if (!mediaCatalogsResult.success) {
            this._startupPromise = null; // Clear the promise
            return startupPromiseResolve({success: false, result: '5'});
          }
          if (!agentResult.success) {
            this._startupPromise = null; // Clear the promise
            return startupPromiseResolve({success: false, result: '7'});
          }

          this._systemInformation.CRMLocalities = localitiesResult.result;
          this._systemInformation.CRMAgents = agentsResult.result;
          this._systemInformation.CRMWhatsappMediaCatalogs = mediaCatalogsResult.result;
          this._systemInformation.CRMAgent = agentResult.result;

          this._startupPromise = null; // Clear the promise
          startupPromiseResolve({success: true, result: this._systemInformation});
        }).catch((error) => {
          console.error('Error during startup:', error);
          this._startupPromise = null; // Clear the promise
          startupPromiseResolve({success: false, result: '9'});
        });

      } catch (error) {
        console.error('Error in startup:', error);
        this._startupPromise = null; // Clear the promise
        startupPromiseResolve({success: false, result: '9'});
      }
    }); 

    return this._startupPromise;
  }

  loadCRMLocalities() {
    return new Promise((loadCRMLocalitiesPromiseResolve) => {
      try {
        const selectCRMLocalitiesViewRequestQuery = 
        {
          'localStorage': 
          {
            'CRMAccountID': this._systemInformation.CRMAccountID
          }
        };
        this._generalFunctions.executeHttpPOSTRequest('/CRMLocality/systemInformation/selectCRMLocality', selectCRMLocalitiesViewRequestQuery).then(selectCRMLocalityFromCRMLocalitiesViewResult => {
          if (selectCRMLocalityFromCRMLocalitiesViewResult.success) {
            loadCRMLocalitiesPromiseResolve({success: true, result: selectCRMLocalityFromCRMLocalitiesViewResult.result});
          } else {
            loadCRMLocalitiesPromiseResolve({success: false, result: null});
          }
        }).catch(() => {
          loadCRMLocalitiesPromiseResolve({success: false, result: null});
        });  
      } catch {
        loadCRMLocalitiesPromiseResolve({success: false, result: null});
      }
    });
  }

  loadCRMWhatsappMediaCatalogs() {
    return new Promise((loadCRMWhatsappMediaCatalogsPromiseResolve) => {
      const selectCRMWhatsappMediaCatalogsViewRequestQuery = 
      {
        'localStorage': 
        {
          'CRMAccountID': this._systemInformation.CRMAccountID
        }
      };
      this._generalFunctions.executeHttpPOSTRequest('/CRMWhatsappMediaCatalog/functions/selectCRMWhatsappMediaCatalogFromMediaCatalogView', selectCRMWhatsappMediaCatalogsViewRequestQuery).then(selectCRMWhatsappMediaCatalogFromCRMWhatsappMediaCatalogsViewResult => {
        if (selectCRMWhatsappMediaCatalogFromCRMWhatsappMediaCatalogsViewResult.success) {
          selectCRMWhatsappMediaCatalogFromCRMWhatsappMediaCatalogsViewResult.result.forEach(CRMWhatsappMediaCatalog => {
            CRMWhatsappMediaCatalog.CRMWhatsappMediaCatalogMedias.filter(CRMWhatsappMediaCatalogMedia => CRMWhatsappMediaCatalogMedia.CRMWhatsappMediaCatalogMediaExtension == 'pdf').forEach(async CRMWhatsappMediaCatalogMedia => {
              try {
                CRMWhatsappMediaCatalogMedia.CRMWhatsappMediaCatalogMediaBlob = URL.createObjectURL((await (await fetch(CRMWhatsappMediaCatalogMedia.CRMWhatsappMediaCatalogMediaURL)).blob()));
              } catch {
                CRMWhatsappMediaCatalogMedia.CRMWhatsappMediaCatalogMediaBlob = null;
              }
            });
          });
          loadCRMWhatsappMediaCatalogsPromiseResolve({success: true, result: selectCRMWhatsappMediaCatalogFromCRMWhatsappMediaCatalogsViewResult.result});
        } else {
          loadCRMWhatsappMediaCatalogsPromiseResolve({success: false, result: null});
        }
      }).catch(() => {
        loadCRMWhatsappMediaCatalogsPromiseResolve({success: false, result: null});
      });
    });
  }

  loadCRMAgents() {
    return new Promise((loadCRMAgentsPromiseResolve) => {
      const selectCRMAgentsRequestQuery = 
      {
        'localStorage': 
        {
          'CRMAccountID': this._systemInformation.CRMAccountID
        }
      };
      this._generalFunctions.executeHttpPOSTRequest('/CRMAgent/systemInformation/selectCRMAgents', selectCRMAgentsRequestQuery).then(selectCRMAgentsResult => {
        if (selectCRMAgentsResult.success) {
          loadCRMAgentsPromiseResolve({success: true, result: selectCRMAgentsResult.result});
        } else {
          loadCRMAgentsPromiseResolve({success: false, result: null});
        }
      }).catch(() => {
        loadCRMAgentsPromiseResolve({success: false, result: null});
      });
    });
  }

  loadCRMAgent() {
    return new Promise((loadCRMAgentPromiseResolve) => {
      const selectCRMAgentRequestQuery = 
      {
        'localStorage': 
        {
          'CRMAccountID': this._systemInformation.CRMAccountID,
          'CRMAgentID': this._systemInformation.CRMAgentID
        }
      };
      this._generalFunctions.executeHttpPOSTRequest('/CRMAgent/systemInformation/selectCRMAgent', selectCRMAgentRequestQuery).then(selectCRMAgentResult => {
        if (selectCRMAgentResult.success) {
          loadCRMAgentPromiseResolve({success: true, result: selectCRMAgentResult.result});
        } else {
          loadCRMAgentPromiseResolve({success: false, result: null});
        }
      }).catch(() => {
        loadCRMAgentPromiseResolve({success: false, result: null});
      });
    });
  }

  get getSystemInformation() {
    return this._systemInformation;
  }

  get getCRMAccountID() {
    return this._systemInformation.CRMAccountID;
  }

  get getCRMAgentID() {
    return this._systemInformation.CRMAgentID;
  }

  get getTooltipDisabled() {
    return this._systemInformation.tooltipDisabled;
  }

  get getVolumeLevel() {
    return this._systemInformation.volumeLevel;
  }

  get getCRMWhatsappMessageNotificationDisabled() {
    return this._systemInformation.CRMWhatsappMessageNotificationDisabled;
  }

  get getCRMLocalities() {
    return this._systemInformation.CRMLocalities;
  }

  get getCRMAgents() {
    return this._systemInformation.CRMAgents;
  }

  get getCRMWhatsappMediaCatalogs() {
    return this._systemInformation.CRMWhatsappMediaCatalogs;
  }

  get getCRMAgent() {
    return this._systemInformation.CRMAgent;
  }

  setGeneralFunctions(generalFunctions) {
    this._generalFunctions = generalFunctions;
  }

  setTooltipDisabled(tooltipDisabled) {
    this._systemInformation.tooltipDisabled = tooltipDisabled;
    localStorage.setItem('tooltipDisabled', tooltipDisabled);
    this.notifySubscribersOfUpdate();
  }

  setVolumeLevel(volumeLevel) {
    this._systemInformation.volumeLevel = volumeLevel;
    localStorage.setItem('volumeLevel', volumeLevel);
    this.notifySubscribersOfUpdate();
  }

  setCRMAgentColor(CRMAgentColor) {
    this._systemInformation.CRMAgent.CRMAgentColor = CRMAgentColor;
    this.notifySubscribersOfUpdate();
  }

  setCRMAgentFontColor(CRMAgentFontColor) {
    this._systemInformation.CRMAgent.CRMAgentFontColor = CRMAgentFontColor;
    this.notifySubscribersOfUpdate();
  }

  setCRMAgentProfilePictureURL(CRMAgentProfilePictureURL) {
    this._systemInformation.CRMAgent.CRMAgentProfilePictureURL = CRMAgentProfilePictureURL;
    localStorage.setItem('CRMAgentProfilePictureURL', CRMAgentProfilePictureURL);
    this.notifySubscribersOfUpdate();
  }

  setCRMAgentBackgroundURL(CRMAgentBackgroundURL) {
    this._systemInformation.CRMAgent.CRMAgentBackgroundURL = CRMAgentBackgroundURL;
    localStorage.setItem('CRMAgentBackgroundURL', CRMAgentBackgroundURL);
    this.notifySubscribersOfUpdate();
  }

  setCRMAgentOwnMessageColor(CRMAgentOwnMessageColor) {
    this._systemInformation.CRMAgent.CRMAgentOwnMessageColor = CRMAgentOwnMessageColor;
    localStorage.setItem('CRMAgentOwnMessageColor', CRMAgentOwnMessageColor);
    this.notifySubscribersOfUpdate();
  }

  setCRMAgentContactMessageColor(CRMAgentContactMessageColor) {
    this._systemInformation.CRMAgent.CRMAgentContactMessageColor = CRMAgentContactMessageColor;
    localStorage.setItem('CRMAgentContactMessageColor', CRMAgentContactMessageColor);
    this.notifySubscribersOfUpdate();
  }

  setCRMWhatsappMessageNotificationDisabled(CRMWhatsappMessageNotificationDisabled) {
    this._systemInformation.CRMWhatsappMessageNotificationDisabled = CRMWhatsappMessageNotificationDisabled;
    localStorage.setItem('CRMWhatsappMessageNotificationDisabled', CRMWhatsappMessageNotificationDisabled);
    this.notifySubscribersOfUpdate();
  }

  subscribeToUpdate(subscriberToUpdate) {
    this._subscribersToUpdate.add(subscriberToUpdate);
    subscriberToUpdate(this._systemInformation);
    return () => this._subscribersToUpdate.delete(subscriberToUpdate);
  }

  unsubscribeFromUpdate(subscriberToUpdate) {
    this._subscribersToUpdate.delete(subscriberToUpdate);
  }

  notifySubscribersOfUpdate() {
    this._subscribersToUpdate.forEach(subscriberToUpdate => subscriberToUpdate(this._systemInformation));
  }

  async refresh() {
    this._systemInformation = null;
    this._startupPromise = null; // Clear any ongoing startup promise
    return this.startup();
  }
}

export const systemInformation = new SystemInformation(); 